var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.snackbarShow
    ? _c("snackbar", {
        attrs: {
          title: _vm.title,
          subTitle: _vm.subTitle,
          closeButtonText: "닫기",
          buttonText: "인증하기",
        },
        on: { close: _vm.snackbarClose, complete: _vm.onComplete },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }